import {flatten, identity, uniqBy} from 'lodash';
import {useMemo} from 'react';
import {useMeetings} from './useMeetings';

export function useMeetingRelatedUsers(eventId) {
    const meetings = useMeetings(eventId);

    return useMemo(() => {
        let users = flatten(meetings.map(meeting => [meeting.initiator, ...meeting.invited.map(invited => invited.user)]));
        users = users.filter(identity);
        users = uniqBy(users, 'id');
        return users;
    }, [meetings]);
}
